import { render, staticRenderFns } from "./SaleImportModal.vue?vue&type=template&id=f6145810&scoped=true&"
import script from "./SaleImportModal.vue?vue&type=script&lang=js&"
export * from "./SaleImportModal.vue?vue&type=script&lang=js&"
import style0 from "./SaleImportModal.vue?vue&type=style&index=0&id=f6145810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6145810",
  null
  
)

export default component.exports